import { NavLink, Route, Routes } from "react-router-dom";
import { MessageSquare, Upload as UploadIcon, FolderOpen } from "lucide-react";
import { ChatPage } from "@/pages/ChatPage";
import { UploadPage } from "@/pages/UploadPage";
import { DocsPage } from "@/pages/DocsPage";
import { cn } from "@/lib/utils";

function NavItem({ to, icon: Icon, label }: { to: string; icon: typeof MessageSquare; label: string }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        cn(
          "flex flex-1 flex-col items-center gap-1 py-2 text-xs font-medium transition-colors",
          isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground",
        )
      }
    >
      <Icon className="h-5 w-5" />
      <span>{label}</span>
    </NavLink>
  );
}

export default function App() {
  return (
    <div className="flex h-full flex-col">
      <header className="border-b bg-background/80 px-4 py-3 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <h1 className="text-base font-semibold tracking-tight">vault.leffel.io</h1>
      </header>
      <main className="flex-1 overflow-hidden">
        <Routes>
          <Route path="/" element={<ChatPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/docs" element={<DocsPage />} />
        </Routes>
      </main>
      <nav className="grid grid-cols-3 border-t bg-background/80 backdrop-blur supports-[backdrop-filter]:bg-background/60 pb-[env(safe-area-inset-bottom)]">
        <NavItem to="/" icon={MessageSquare} label="Ask" />
        <NavItem to="/upload" icon={UploadIcon} label="Upload" />
        <NavItem to="/docs" icon={FolderOpen} label="Docs" />
      </nav>
    </div>
  );
}
